import React, {useEffect, useState} from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Typography } from '@mui/material';
import  PropTypes from 'prop-types';
import { getTotalMaterials } from '../../services/material-services';
// import ProgressWait from '../layout/progress';
import { useAuth } from '../../hooks/useAuth';
import { blue } from '@mui/material/colors';


export default function MaterialSelectAuto({onChange, selectedValue, selectedIndex}) {
    const { authData, authDataGroup, authDataLang } = useAuth()

    const [materials, setMaterials] = useState('')
    // const [error, setError] = useState(false)
    const [loading, setLoding] = useState(false)
    const [defaultVal, setDefaultVal] = useState('')
    
    useEffect(()=>{
        const getData = async () =>{
            setLoding(true)
            let querys = ''
            if (authDataGroup?.name){
              querys = `&type_data=${authDataGroup?.name}`
            }
            await getTotalMaterials(authData?.token, querys)
            .then(data => {
                // console.log('data', selectedValue, data)
                if(data?.results){
                    setMaterials(data?.results)
                    if(selectedIndex){
                        const nameList = data?.results.filter(v => v.id === selectedIndex)[0]
                        setDefaultVal(nameList)
                    }else{
                        if(selectedValue){
                            const nameList = data?.results.filter(v => v.name === selectedValue?.name)[0]
                            // console.log("nameList", nameList)
                            setDefaultVal(nameList)
                        }
                    }
                }
                setLoding(false)
            }).catch( e => {
                // setError(true)
                setLoding(false)
            })
        }
      getData()
      // console.log('selectedValue', selectedValue)
    }, [authData, authDataGroup, selectedValue, selectedIndex])

    // if (error) return <h1> Error </h1> 
    // if (loading) return <ProgressWait /> 

    const handleListItemClick = (value) => {
        setDefaultVal(value)
        onChange(value)
    }

  return (
    <Autocomplete
      defaultValue={defaultVal}
      value={defaultVal || null || ""}
      onChange={(event, newValue) => {
          handleListItemClick(newValue)
      }}
      // onClick={(event, newValue) => {
      //     handleListItemClick(newValue)
      // }}
      // inputValue={selectedValue}
      // onInputChange={(event, newInputValue) => {
      //   handleListItemClick(newInputValue)
      // }}
      
      id="mat-select-control"
      sx={authDataLang?.view_sts ? 
        { width: 300, fontFamily: 'b_mitra', fontSize: 24, direction: 'ltr' } 
        : 
        { width: 300, fontFamily: 'b_mitra', fontSize: 24, direction: 'rtl' }
      }
      options={materials}
      isOptionEqualToValue={(option, value) => option.id === value.id || null || ""}
      autoHighlight
      getOptionLabel={(option) =>  option.name  || null || ""}
      renderOption={(props, option) => (
        <Box component="li" 
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} 
          dir={authDataLang?.view_sts ? "rtl" : "ltr"}
          >
          <img
            loading="lazy"
            width="20"
            src={option.image}
            srcSet={`${option.image} 2x`}
            alt=""
          />
          
          <Typography
              fontFamily='b_mitra' 
              component="div"
              variant="h6"
              color={blue[900]}
              >
              {option.name}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={(
              <Typography
                  fontFamily='b_mitra' 
                  component="div"
                  variant="h6"
                  color={blue[900]}
                  >
                  نوع فعالیت را انتخاب کنید
              </Typography>
          )}

          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            style: { color: blue[900], fontFamily: "b_mitra"}
          }}
        />
      )}
    />
  )
}
// MaterialSelectAuto
// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

MaterialSelectAuto.propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
}

